import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const episodeApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/episodes/`, {params: params})
  },
  detail (episodeId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/episodes/${episodeId}/`, {params: params})
  }
}

export default episodeApi
